<template>
	<v-dialog
			content-class="uploadComponentWrapper"
			:value="true"
			fullscreen
			hide-overlay
			persistent
			transition="dialog-bottom-transition"
	>
		<div class="uploadComponent">
			<div class="uploadComponent_header">
				<span>Upload file</span>
				<button type="button" @click="closeDialog">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<update-table
					v-if="rows"
					:items="rows"
					:keyHeader="keyHeader"
					:keyTable="keyTable"
			></update-table>
			<div v-else class="uploadComponent_body">
				<upload-file
						@updateFile="onFile"
				></upload-file>
			</div>
			<button-groups
					@updateBtnClose="closeDialog"
					@updateSave="onSave"
			></button-groups>
		</div>
		<preload v-if="isPreloader"></preload>
	</v-dialog>
</template>

<script>
// component
import Preload from "@/shared/Preload/Preload";
import UpdateTable from '@/components/Accounting/Fuel/UpdateTable/UploadTable';
// validate
import { validationMixin } from "vuelidate";
// shared
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import UploadFile from "@/shared/UploadFile/UploadFile";

export default {
	name: "UploadComponent",
	mixins: [ validationMixin ],
	components: {
		ButtonGroups,
		Preload,
		UploadFile,
		UpdateTable
	},
	props: {
		keysRequest: Object,
		keyHeader: String,
		keyTable: String
	},
	data: () => ({
		isPreloader: false,
		file: null,
		rows: null
	}),
	methods: {
		async onFile(value) {
			this.file = value;
			if (value) {
				this.isPreloader = true;
				const response = await this.$store.dispatch(`${ this.keysRequest.get }`, value);
				if (response) {
					this.rows = response.rows;
				}
				this.isPreloader = false;
			}
		},
		closeDialog() {
			this.$emit('updateClose');
		},
		async onSave() {
			this.isPreloader = true;
			await this.$store.dispatch(`${ this.keysRequest.set }`, this.rows);
			this.closeDialog();
			this.isPreloader = false;
		}
	}
};
</script>

<style scoped lang="scss">
@import "uploadComponent";
</style>

<style lang="scss">
@import "uploadComponentGlobal";
</style>

